const LOGO_URL = "https://customer-assets-cm19k8pv.emergentagent.net/job_swag-marketplace-1/artifacts/b8b5ppb4_ChatGPT%20Image%20Oct%201%2C%202026%20at%2003_32_53%20PM.webp";

// The uploaded brand asset is a 2x2 composite of CS logo lockups.
// Top-right panel: black CARZ + red SWAG on white (use on light backgrounds)
// Bottom-left panel:  white lockup on dark/red (use on dark backgrounds)
// We render it via background-image to avoid stray boxes / wrong aspect ratios.
export const CSLogo = ({ variant = "dark", className = "" }) => {
  const isLight = variant === "light";
  return (
    <div
      className={`inline-block select-none ${className}`}
      role="img"
      aria-label="CARZ SWAG"
      data-testid="cs-logo"
      style={{
        backgroundImage: `url(${LOGO_URL})`,
        backgroundRepeat: "no-repeat",
        backgroundSize: "200% 200%",
        backgroundPosition: isLight ? "0% 100%" : "100% 0%",
      }}
    />
  );
};

export const CSLogoImage = CSLogo;
